import { render, staticRenderFns } from "./ComplaintDetailAppraise.vue?vue&type=template&id=df41590a&scoped=true"
import script from "./ComplaintDetailAppraise.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailAppraise.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetailAppraise.vue?vue&type=style&index=0&id=df41590a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df41590a",
  null
  
)

export default component.exports